import React from 'react'
import { useSearchParams } from 'react-router-dom'
import EmptyPage from 'layout/access-management/empty-page'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import { split } from 'lodash'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useDataAccess } from 'api/hooks/use-data-accesses'
import Employees from './tabs/employees'
import Roles from './tabs/roles'
import AuditLog from 'duties/overview/audit-log'
import Tabs from 'duties/shared/tabs'
import AccountsTab from './accounts'

const VALID_TABS = ['accounts', 'employees', 'roles', 'audit-log']

function DataAccess() {
  const path = window.location.pathname
  const dataAccessId = split(path, '/')[2]
  const [searchParams, setSearchParams] = useSearchParams()
  const { isSuccess, isLoading, data: dataAccess } = useDataAccess({ params: { id: dataAccessId } })

  // Determine if accounts tab should be shown (glacctgrp only)
  const showAccountsTab = isSuccess && dataAccess?.category === 'glacctgrp'

  // Default to accounts tab if available, otherwise employees
  const defaultTab = showAccountsTab ? 'accounts' : 'employees'

  // Get active tab from URL, falling back to default
  const tabParam = searchParams.get('tab')
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : defaultTab

  // Update URL when tab changes
  const setActiveTab = (tab) => {
    setSearchParams({ tab }, { replace: true })
  }

  
  if (isLoading) {
    return <EmptyPage />
  }

  const crumbs = [
    { name: 'Access Management', url: 'duties' },
    { name: 'Data Access', url: 'data-access' },
    { name: isSuccess ? dataAccess.name : '', url: '' }
  ]

  return (
    <Page title={`Data Access`} subtitle={''}>
      <PageTitle breadcrumbs={crumbs} />
      {isSuccess && (
        <>
          <h4 className="my-4">{dataAccess.name}</h4>

          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <Row>
                    <Col sm={2}>
                      <span className="fw-bold">Module</span>
                      <div className="fw-light mt-2">
                        {dataAccess.top_module_name}
                      </div>
                    </Col>
                    <Col sm={2}>
                      <span className="fw-bold">Code</span>
                      <div className="fw-light mt-2">{dataAccess.category}</div>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col sm={12}>
                      <div className="fw-bold">Description</div>
                      <div className="fw-light mt-2">
                        {dataAccess.description}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Row className="mt-4">
                <Col sm={12}>
                  <div className="d-flex mb-3">
                    <Tabs
                      tabs={[
                        ...(showAccountsTab ? [{ name: 'Accounts', value: 'accounts' }] : []),
                        { name: 'Users', value: 'employees' },
                        { name: 'Roles', value: 'roles' },
                        { name: 'Audit Log', value: 'audit-log' }
                      ]}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}

      {activeTab === 'employees' && isSuccess && (
        <Employees dataAccessId={dataAccessId} />
      )}

      {activeTab === 'roles' && isSuccess && (
        <Roles dataAccessId={dataAccessId} />
      )}

      {showAccountsTab && activeTab === 'accounts' && (
        <AccountsTab />
      )}

      {activeTab === 'audit-log' && <AuditLog dataAccessId={dataAccessId} />}
    </Page>
  )
}

export default DataAccess
